import call from './call';
import handleBase64ZipResponse from "../helpers/handleBase64ZipResponse";

export default (form) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1].success) {
            handleBase64ZipResponse(result[1].result, "reports.zip");
        }
    };
    dispatch(call("SystemService/getReports",form,onResult));
};